import { createUseStyles } from '../../theme/theming';

const useVideoStyles = createUseStyles((theme) => {
  return {
    videoSuperContainer: {
      padding: ({ isMobile } = {}) =>
        isMobile
          ? `${theme.spacing.padding.regular}px ${theme.spacing.padding.small}px`
          : `${theme.spacing.padding.small}px ${theme.spacing.padding.medium}px`,
      backgroundColor: theme?.colors?.background2,

      '&, & *, & *:before, & *:after': {
        fontFamily: theme?.typography?.fontFamily,
        boxSizing: 'border-box'
      },
      '& h3': {
        marginTop: '0'
      }
    },
    sectionContainer: {
      margin: '0 auto',
      maxWidth: ({ containerWidth } = {}) => containerWidth
    },

    // videoContainer: {
    //   marginTop: '70px'
    // },

    videoHeading: {
      fontSize: theme.typography.fontSize.subHead,
      textTransform: 'uppercase',
      lineHeight: '20px',
      color: theme?.colors?.font2,
      letterSpacing: '3px',
      wordBreak: 'break-word'
    },

    videoTitle: {
      fontSize: theme.typography.fontSize.h2,
      fontWeight: theme.typography.fontWeight.bold,
      lineHeight: '71px',
      letterSpacing: '-3px',
      marginBottom: theme.spacing.margin.tiny,
      marginTop: '8px',
      color: theme?.colors?.font2,
      wordBreak: 'break-word'
    },

    sliderContainer: {
      marginRight: `-${theme.spacing.padding.medium}px`
    },

    singleSlideContainer: {
      backgroundColor: 'white',
      // margin: '20px',
      width: 'calc(100% - 24px)',
      height: 'calc(100% - 40px)',
      borderRadius: theme?.shape?.borderRadius?.regular,
      padding: '64px',
      boxShadow: theme?.shadows?.primary
    },

    contentRow: {
      display: 'grid',
      gridTemplateColumns: ({ slidesToShow } = {}) =>
        `repeat(${slidesToShow},minmax(0, 1fr))`
    },

    iframeContainer: {
      width: '100%',
      borderRadius: theme?.shape?.borderRadius?.regular,
      position: 'relative',
      overflow: 'hidden',
      paddingBottom: '56.25%'
    },

    iframe: {
      position: 'absolute',
      width: '100%',
      height: '100%',
      borderRadius: theme?.shape?.borderRadius?.regular,
      borderRadius: theme.shape.borderRadius.small
    },

    videoDetailsContainer: {
      textAlign: 'center',
      margin: '12px 12px 0'
    },

    videoDetailsHeading: {
      fontSize: theme.typography.fontSize.h5,
      fontWeight: theme.typography.fontWeight.bold,
      lineHeight: '32px',
      marginBottom: '8px',
      color: theme?.colors?.lightblack,
      wordBreak: 'break-word'
    },

    videoDetailsSubHeading: {
      fontSize: theme.typography.fontSize.body,
      lineHeight: '24px',
      wordBreak: 'break-word',
      color: theme?.colors?.gray
    },

    '@media (max-width: 767px)': {
      videoHeading: {
        lineHeight: '20px'
      },
      videoContainer: {
        margin: '0'
      },
      sliderContainer: {
        // marginLeft: '-6px',
        marginRight: '0px'
      },

      singleSlideContainer: {
        padding: '16px',
        width: 'calc(100% - 12px)',
        height: 'calc(100% - 24px)',
        margin: '0px 6px 16px 6px'
      },

      iframe: {
        borderRadius: '8px 8px 0 0'
      },

      videoDetailsContainer: {
        textAlign: 'left',
        margin: '12px 12px 0'
      },

      videoTitle: {
        display: 'flex',
        justifyContent: 'center',
        textAlign: 'center',
        lineHeight: '36px',
        letterSpacing: '-1px'
      },
      videoHeading: {
        display: 'flex',
        justifyContent: 'center',
        textAlign: 'center'
      },
      videoDetailsHeading: {
        fontSize: '20px',
        marginBottom: '0',
        textAlign: 'center'
      },
      videoDetailsSubHeading: {
        fontSize: '14px',
        textAlign: 'center'
      }
    }
  };
});

export default useVideoStyles;
